module.exports = __webpack_public_path__ + "media/images/wendys-txt-7d9d34081f10e9d88fb8e55dab7804e4.png";